import { assignDefaultValue, latencyToColorName } from "@/libs/rcmTableFieldsFunction";
import { checkDocumentExist } from "@/api/documentexist";
import ClearCacheBtn from "@/components/ClearCacheBtn";
import Vue from "vue";
Vue.component("ClearCacheBtn", ClearCacheBtn);

export const settingZoneExplain = (parentVue) => {
    return {
        description: "<p>App Profiles are versatile, keep your configs neat and clean using app profiles.</p>",
        // "<p>Here is the place you can <strong>create, edit, and delete</strong> your domains. As a domain can includes a bunch of setting, we've split them into 3 main part, so after you create your domain in our CDN, you may also check with the <a href='/cacherules'>Cache Rules</a> and <a href='/wafrules'>Waf Rules</a>.</p>"
    };
};

export const appProfileName = (parentVue) => {
    return {
        description: "<p>The name of the domain profile.</p>",
        formTypes: ["createForm"],
        formRender: "FormInput",
        placeholder: "example.com.profile",
        validate: [
            {
                required: true,
                message: `${parentVue.$i18n.t("domainsetting.appProfileName")}${parentVue.$i18n.t(
                    "rcmtable.validateEmptyText"
                )}`,
                trigger: "blur",
            },
            {
                validator: async (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;

                    if (!/^[a-z0-9\-\_\.]*$/.test(value))
                        return callback(
                            new Error(`${vm.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _ .`)
                        );
                    if (value.split(".").length < 2)
                        return callback(`${vm.$i18n.t("rcmtable.validateInputMustContainDots")}`);

                    let checkDocumentExistResult = await checkDocumentExist({
                        topic: "appProfileName",
                        fieldVal: value,
                        groupName: vm.formData.groupName,
                    });
                    if (value.length > 35)
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 35`));

                    if (!checkDocumentExistResult.data.success)
                        return callback(new Error("Domain profile name can't be used"));
                    callback();
                },
                trigger: "blur",
            },
        ],
        render: (h, params) => {
            var enterProfileDomainStyle = parentVue.$store.getters.getAppProfileConfig.enterProfileDomainStyle;
            const linkElement = h(
                enterProfileDomainStyle,
                {
                    props: {
                        type: "text",
                    },
                    on: {
                        click: () => {
                            parentVue.$router.push({
                                name: "ProfileDomain",
                                params: {
                                    appProfileName: params.row.appProfileName,
                                },
                                query: { groupName: params.row.groupName },
                            });
                        },
                    },
                },
                params.row.appProfileName
            );

            const tags = assignDefaultValue(params.row.tags, []);
            const appProfileTags = tags.map((tagName) => h("Tag", {}, tagName));

            const elements = [linkElement, ...appProfileTags];
            return h("span", {}, elements);
        },
    };
};

export const serviceGroupName = (parentVue) => {
    return {
        description:
            "<p>A <strong>ServiceGroup</strong> is a combination of <strong>Slbs</strong>, you can setup multiple ServiceGroups to make your own strategy. click <router-link to='servicegroup'>here</router-link> to manage your ServiceGroups.</p>",
        sectionKey: "essential",
    };
};

export const customHostHeader = (parentVue) => {
    return {
        vShowFieldVal: (item) => {
            return item.setCustomHostHeader == "on" ? 1 : 0;
        },
    };
};

export const httpPort = (parentVue) => {
    return {
        vShowFieldVal: (item) => {
            return item.scheme.includes("http") ? 1 : 0;
        },
    };
};

export const httpsPort = (parentVue) => {
    return {
        vShowFieldVal: (item) => {
            return item.scheme.includes("https") ? 1 : 0;
        },
    };
};
export const scheme = (parentVue) => {
    return {
        render: (h, params) => {
            return h(
                "div",
                params.row.scheme.map(function (s) {
                    return h(
                        "Tag",
                        {
                            props: {},
                        },
                        s
                    );
                })
            );
        },
    };
};
// export const redirecthttps = (parentVue) => {
//     return {
//         vShowFieldVal: (item) => {
//             return item.scheme.length == 2 ? 1 : 0;
//         },
//     };
// };

export const useHttp2 = (parentVue) => {
    return {
        sectionKey: "http_https",
        vShowFieldVal: (item) => {
            return item.scheme.includes("https") ? 1 : 0;
        },
    };
};

export const useHsts = (parentVue) => {
    return {
        vShowFieldVal: (item) => {
            return item.scheme.includes("https") ? 1 : 0;
        },
    };
};

export const useSystemCert = (parentVue) => {
    return {
        vShowFieldVal: () => 0,
    };
};

export const usedOriginPolicies = (parentVue) => {
    return {
        vShowFieldVal: (item) => {
            return item.useOriginPolicy == true ? 1 : 0;
        },
    };
};

export const origins = (parentVue) => {
    return {
        vShowFieldVal: (item) => {
            return item.useOriginPolicy == false ? 1 : 0;
        },
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            if (params.row.useOriginPolicy == true) {
                return h(
                    "div",
                    {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                        },
                    },
                    [
                        params.row.origins.map(function (o) {
                            return [
                                h(
                                    "div",
                                    {
                                        style: {
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                        },
                                    },
                                    [
                                        h(
                                            "p",
                                            {
                                                style: {
                                                    fontStyle: "italic",
                                                    color: "rgb(204, 204, 204)",
                                                },
                                            },
                                            o
                                        ),
                                    ]
                                ),
                            ];
                        }),
                    ]
                );
            } else {
                if (params.row.portMappingType == "default") {
                    return h(
                        "div",
                        {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                            },
                        },
                        [
                            params.row.origins.map(function (o) {
                                let oStat = vm.getEsResult.originStat.find(
                                    (oStat) =>
                                        oStat.originHost == o &&
                                        oStat.groupName == params.row.groupName &&
                                        oStat.originPort == params.row.originPort
                                );

                                let latency = oStat ? oStat.latency : 0;
                                let statusColor = latencyToColorName(latency);

                                return [
                                    h(
                                        "div",
                                        {
                                            style: {
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                            },
                                        },
                                        [
                                            h("Icon", {
                                                props: {
                                                    type: "ios-radio-button-on",
                                                    color: statusColor,
                                                    size: 16,
                                                },
                                                style: {
                                                    margin: "5px",
                                                },
                                            }),
                                            h("p", `${o}:${params.row.originPort}`),
                                        ]
                                    ),
                                ];
                            }),
                        ]
                    );
                } else {
                    let ports = [...params.row.httpPort, ...params.row.httpsPort];
                    let origins = [...params.row.origins];

                    let originsPortsCombination = origins.map((origin) => {
                        return ports.map((port) => {
                            return { origin: origin, port: port };
                        });
                    });
                    originsPortsCombination = originsPortsCombination.flat();

                    return h(
                        "div",
                        {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                            },
                        },
                        [
                            originsPortsCombination.map(function (o) {
                                let oStat = vm.getEsResult.originStat.find(
                                    (oStat) =>
                                        oStat.originHost == o.origin &&
                                        oStat.groupName == params.row.groupName &&
                                        oStat.originPort == o.port
                                );
                                let latency = oStat ? oStat.latency : 0;
                                let statusColor = latencyToColorName(latency);
                                return [
                                    h(
                                        "div",
                                        {
                                            style: {
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                            },
                                        },
                                        [
                                            h("Icon", {
                                                props: {
                                                    type: "ios-radio-button-on",
                                                    color: statusColor,
                                                    size: 16,
                                                },
                                                style: {
                                                    margin: "5px",
                                                },
                                            }),
                                            h("p", `${o.origin}:${o.port}`),
                                        ]
                                    ),
                                ];
                            }),
                        ]
                    );
                }
            }
        },
    };
};

export const originScheme = (parentVue) => {
    return {
        vShowFieldVal: (item) => {
            return item.useOriginPolicy == false ? 1 : 0;
        },
        options: ["http", "https", "static"],
    };
};

export const portMappingType = (parentVue) => {
    return {
        vShowFieldVal: (item) => {
            return item.useOriginPolicy == false ? 1 : 0;
        },
    };
};

export const originPort = (parentVue) => {
    return {
        vShowFieldVal: (item) => {
            return item.portMappingType == "default" && item.useOriginPolicy == false ? 1 : 0;
        },
    };
};
export const description = (parentVue) => {
    return {
        sectionKey: "essential",
        description:
            "<p>Manage your site with your flavor, setup a description for the site will make your management easier.</p>",
        render: (h, params) => {
            return h(
                "div",
                params.row.description.split("\n").map(function (o) {
                    return h(
                        "P",
                        {
                            props: {},
                        },
                        o
                    );
                })
            );
        },
    };
};

export const maxServerNameInAppProfileCount = (parentVue) => {
    const { currentGroupResourceLimits } = parentVue.$store.getters;
    return {
        sectionKey: "essential",
        showInTable: false,
        inputMinNum: -1,
        defaultVal: -1,
    };
};
export const action = (parentVue) => {
    return {
        width: 180,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;

            const clearCacheBtn = h("ClearCacheBtn", {
                props: {
                    shape: "circle",
                    icon: "md-refresh",
                    disabled: vm.isEditBtnDisabled,
                    selectedItems: [params.row.appProfileName],
                    groupName: params.row.groupName,
                    isAppProfile: true,
                },
            });

            const editBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: vm.isEditBtnDisabled ? "md-eye" : "md-create",
                },
                on: {
                    click: () => {
                        vm.editItem(params.row);
                    },
                },
            });

            const copyBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: "md-copy",
                    disabled: vm.isEditBtnDisabled,
                },
                on: {
                    click: () => {
                        vm.copyItem(params.row);
                    },
                },
            });

            var dropdownItems = [
                {
                    value: "delete",
                    title: vm.$t("rcmtable.deleteText"),
                    modalTitle: vm.$t("rcmtable.deleteText"),
                    modalContent: vm.$t("rcmtable.confirmDeleteText"),
                },
            ];

            const moreBtn = h(
                "Dropdown",
                {
                    props: {
                        trigger: "click",
                        placement: "right",
                        transfer: true,
                        disabled: vm.isDeleteBtnDisabled,
                    },
                    on: {
                        "on-click": (value) => {
                            var currentItem = dropdownItems.find((e) => e.value == value);
                            vm.$Modal.confirm({
                                title: currentItem.modalTitle,
                                content: currentItem.modalContent,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    var deleteItem = Object.assign({}, params.row);
                                    delete deleteItem._index;
                                    delete deleteItem._rowKey;

                                    vm.actionType = "delete";
                                    vm.updateData(vm.esIndex, "delete", deleteItem);
                                },
                            });
                        },
                    },
                },
                [
                    h("a", [
                        h("Button", {
                            props: {
                                shape: "circle",
                                icon: "md-more",
                                key: params.index,
                            },
                        }),
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list",
                        },
                        [
                            dropdownItems.map(function (item) {
                                return h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: item.value,
                                            disabled: item.disabled,
                                        },
                                    },
                                    item.title
                                );
                            }),
                        ]
                    ),
                ]
            );

            const actionDivArray = [clearCacheBtn];

            if (vm.userCanIndex) {
                actionDivArray.push(editBtn);
            }
            actionDivArray.push(copyBtn);
            actionDivArray.push(moreBtn);

            return h("div", actionDivArray);
        },
    };
};



// WEBPACK FOOTER //
// ./src/view/AppProfile/fields.js